<template>
  <div 
    v-if="showBubble"
    class="rgpd-bubble" 
    title="Informations nouvelle version"
    @click="openModal"
  >
    <svg
      class="info-icon"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="currentColor"
      />
      <path
        d="M12 16v-4M12 8h.01"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
  
  <FirstLoginModal 
    :show="showModal" 
    @close="closeModal"
    @validate="closeModal"
  />
</template>

<script setup lang="ts">
import { useTermsAcceptance } from '@/composables/useTermsAcceptance'
import { useAuthStore } from '@/stores/auth'
import { onMounted, ref } from '@vue/runtime-core'
import FirstLoginModal from './FirstLoginModal.vue'

const showBubble = ref(false)
const showModal = ref(false)

const { checkTermsAcceptance } = useTermsAcceptance()
const authStore = useAuthStore()

const openModal = () => {
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
}

onMounted(async () => {
  // Afficher la bulle seulement si l'utilisateur est connecté et a déjà accepté les termes au moins une fois
  if (authStore.user) {
    try {
      const hasAccepted = await checkTermsAcceptance()
      if (hasAccepted) {
        showBubble.value = true
      }
    } catch (error) {
      console.error('Erreur lors de la vérification des termes pour RgpdBubble:', error)
    }
  }
})
</script>

<style scoped>
.rgpd-bubble {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  background: #B70018;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(183, 0, 24, 0.3);
  z-index: 1000;
  transition: all 0.3s ease;
  animation: pulse 2s infinite;
}

.rgpd-bubble:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(183, 0, 24, 0.4);
  animation: none;
}

.info-icon {
  width: 24px;
  height: 24px;
  color: white;
}

@keyframes pulse {
  0% {
    box-shadow: 0 4px 12px rgba(183, 0, 24, 0.3), 0 0 0 0 rgba(183, 0, 24, 0.4);
  }
  70% {
    box-shadow: 0 4px 12px rgba(183, 0, 24, 0.3), 0 0 0 10px rgba(183, 0, 24, 0);
  }
  100% {
    box-shadow: 0 4px 12px rgba(183, 0, 24, 0.3), 0 0 0 0 rgba(183, 0, 24, 0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .rgpd-bubble {
    bottom: 15px;
    left: 15px;
    width: 45px;
    height: 45px;
  }
  
  .info-icon {
    width: 20px;
    height: 20px;
  }
}
</style>